import { IComponentController } from 'angular';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IMonoOccurrence, IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IPaginationClass } from '../../../../../core/services/pagination.service';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IMenuItemForageClass } from '../../../../../core/services/menu/menu-item-forage.service';
import { IStateParamsService } from 'angular-ui-router';
import { IRoute } from '../../../../../core/interfaces/route.interface';

interface IPageCb0013 extends IComponentController {
    monoOccurrence: IMonoOccurrence;
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    unaMultiOccurrenceOptions: IMultiOccurrenceOptions;
    unaMultiOccurrence: IMultiOccurrence;
    tymMultiOccurrenceOptions: IMultiOccurrenceOptions;
    tydMultiOccurrenceOptions: IMultiOccurrenceOptions;
    valeursEcran: any;
}

/* @ngInject */
export default function Cb0013Controller(
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    ecranDetails: IEcranDetailsResourcesEntite,
    Pagination: IPaginationClass,
    Menu: IMenuClass,
    MenuItemForage: IMenuItemForageClass,
    $stateParams: IStateParamsService,
    cb2006Route: IRoute,
    cb0011Route: IRoute
) {
    const vm: IPageCb0013 = this;

    vm.valeursEcran = ecranDetails.valeurs;

    vm.tymMultiOccurrenceOptions = {
        bloc: 'tym',
        colonnesVisibles: [
            { nom: 'tyhdsc', largeur: 250 },
            { nom: 'mntsum', largeur: 130 },
            { nom: 'mntimp', largeur: 120, total: true }
        ],
        pagination: new Pagination({
            nombreElementPage: 5,
            nbElementsPossibles: [5, 10, 25]
        })
    };

    vm.unaMultiOccurrenceOptions = {
        bloc: 'una',
        fonctions: {
            rechercheCollapsable: false,
            effaceCriteres: true
        },
        actionsMoreLigne: new Menu([
            new MenuItemForage(
                'LBL_BTN_FORAGE_CB0011',
                cb0011Route.NAME,
                (rowData: any) => ({
                    id: rowData.elecleint,
                    niveau: $stateParams.niveau,
                    elecleint: rowData.elecleint,
                    unacleint: rowData.unacleint,
                    vaesysnatctb: $stateParams.vaesysnatctb,
                    indcleint: $stateParams.indcleint,
                    anncivfin: $stateParams.anncivfin,
                    peccoddeb: vm.valeursEcran.peccoddebcri,
                    peccodfin: vm.valeursEcran.peccodfincri,
                    menuId: $stateParams.menuId
                }),
                {
                    fonction: 'BTN_AVO_FORAGE_CB0011',
                    icon: 'exit_to_app'
                }
            )
        ]),
        criteresSuggeres: new Formulaire([
            new FormulaireItem( 'niveaucri', {
                default: $stateParams.niveau,
                hidden: true
            }),
            new FormulaireItem( 'typpercri', {
                default: $stateParams.anncivfin,
                hidden: true
            }),
            new FormulaireItem('peccleintdebcri', {
                default: vm.valeursEcran.peccleintdeb,
                readonly: true
            }),
            new FormulaireItem('peccleintfincri', {
                default: vm.valeursEcran.peccleintfin,
                readonly: true
            }),
            new FormulaireItem('indcleintcri', {
                default: vm.valeursEcran.indcleintcri,
                readonly: true
            }),
            new FormulaireItem('vaesysnatctbcri', {
                default: vm.valeursEcran.vaesysnatctbcri,
                readonly: true
            })
        ]),
        colonnesVisibles: [
            { nom: 'unacod', largeur: 100 },
            { nom: 'unadsc', largeur: 250 },
            { nom: 'mntsum', largeur: 130, total: true }
        ],
        colonnesCachees: [
            'elecleint',
            'unacleint'
        ],
        pagination: new Pagination({
            nombreElementPage: 5,
            nbElementsPossibles: [5, 10, 25]
        }),
        multiOccurrenceOptionsEnfant: vm.tymMultiOccurrenceOptions
    };

    vm.tydMultiOccurrenceOptions = {
        bloc: 'tyd',
        actionsRangeeDroite: new Menu([
            new MenuItemForage(
                'LBL_DETAIL',
                cb2006Route.NAME,
                (rowData: any) => ({
                    niveau: $stateParams.niveau,
                    type: 'UNA',
                    elecleint: $stateParams.elecleint,
                    unacleint: rowData.unacleint,
                    vaesysnatctb: $stateParams.vaesysnatctb,
                    tymcleint: rowData.tymcleint,
                    tydcleint: rowData.tydcleint,
                    peccleintdeb: vm.unaMultiOccurrence.etatSelected.criteresSuggeresData.peccleintdebcri,
                    peccleintfin: vm.unaMultiOccurrence.etatSelected.criteresSuggeresData.peccleintfincri
                }),
                {
                    icon: 'exit_to_app',
                    fonction: 'BOUDOC',
                    iconButton: true
                }
            )
        ]),
        colonnesVisibles: [
            { nom: 'tyddsc', largeur: 130 },
            { nom: 'mntsum', largeur: 120 }
        ],
        colonnesCachees: [
            'unacleint',
            'tymcleint',
            'tydcleint'
        ]
    };
}
